var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm-modal',{ref:"modal"},[_c('template',{slot:"body"},[_c('p',[_vm._v("Deseja realmente cancelar sua assinatura? Você ainda poderá utilizar seus créditos conforme a política de validade dos mesmos.")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }